import { Card, Text, Title, Table, TableHead, TableHeaderCell, TableBody, TableRow, TableCell } from '@tremor/react';
import { formatInt, formatMxn } from '../lib/format';
import { t } from '../lib/i18n';
import { usePagination } from '../lib/usePagination';
import Pagination from './Pagination';
import type { SlowMover, Store } from '../api/types';
import DrillCell from './DrillCell';

interface Props {
  rows: SlowMover[];
  stores: Store[];
}

export default function SlowMoversList({ rows, stores }: Props) {
  const storeName = (sid: number) => stores.find((s) => s.sid === sid)?.name ?? `#${sid}`;
  const pg = usePagination(rows);
  return (
    <Card>
      <Title>{t.tables.slowMoversTitle}</Title>
      {rows.length === 0 ? (
        <Text className="mt-4">{t.tables.emptySlowMovers}</Text>
      ) : (
        <div
          className="mt-4 overflow-auto print-expand border border-tremor-border rounded-tremor-default"
          style={{ maxHeight: '50vh' }}
        >
          <Table>
            <TableHead className="sticky top-0 bg-tremor-background z-10 shadow-sm">
              <TableRow>
                <TableHeaderCell>{t.tables.cols.part}</TableHeaderCell>
                <TableHeaderCell>{t.tables.cols.description}</TableHeaderCell>
                <TableHeaderCell>{t.tables.cols.store}</TableHeaderCell>
                <TableHeaderCell className="text-right">{t.tables.cols.onHand}</TableHeaderCell>
                <TableHeaderCell className="text-right">{t.tables.cols.value}</TableHeaderCell>
                <TableHeaderCell className="text-right">{t.tables.cols.daysIdle}</TableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pg.pageRows.map((r) => (
                <TableRow key={`${r.line}-${r.part}-${r.sid}`}>
                  <TableCell className="font-mono text-xs">
                    <DrillCell target={{ kind: 'inv', sid: r.sid, line: r.line, part: r.part }}>
                      {r.line} {r.part}
                    </DrillCell>
                  </TableCell>
                  <TableCell>{r.pdesc}</TableCell>
                  <TableCell>{storeName(r.sid)}</TableCell>
                  <TableCell className="text-right tabular-nums">{formatInt(r.on_hand)}</TableCell>
                  <TableCell className="text-right tabular-nums">{formatMxn(r.value_mxn)}</TableCell>
                  <TableCell className="text-right tabular-nums">{formatInt(r.days_since_last_sale)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
      <Pagination {...pg} />
    </Card>
  );
}
